import { memo, useEffect, useState } from 'react';
import { UserCircle, DollarSign, User, Home, Briefcase, Newspaper, CreditCard } from 'lucide-react';

import { MenuNavigation } from '@monorepo/common';

import { useDispatch } from 'react-redux';
import { toggleLeftSide } from '../features/ui/sliceMobileMenu';
import { book } from '../routers/books';
import { useGetMenuSettings } from '../hooks/use-menu-settings';
import { useAppSelector } from '../store/hooks';
import { cpgJobsUrls } from '../routers/jobsRedirect';

// interface IMenuInternalLinksProps {}
export const ProjectNavigation = memo(() => {
  const dispatch = useDispatch();
  const { data, isLoading } = useGetMenuSettings();

  const [brandsLinks, setBrandsLinks] = useState<
  { title: string; href: string; extraInternalLinks?: string[] }[]
  >([]);

  useEffect(() => {
    if (data?.userBrands) {
      const { userBrands } = data;
      userBrands.map((item) => setBrandsLinks((brand) => [
        ...brand,
        {
          title: item.brandName,
          href: book.brands.brandOptions(item.brandGuid),
          subMenus: [{
            title: 'Update Brand Information',
            href: book.brands.editBrand(item.brandGuid)
          }, {
            title: 'Existing Products',
            href: book.brands.editProducts(item.brandGuid)
          }, {
            title: 'Add Product',
            href: book.brands.createProduct(item.brandGuid)
          }, {
            title: 'Add Sub Brand',
            href: book.brands.createSubBrand(item.brandGuid)
          },
          {
            title: 'View Public Page',
            href: `https://www.bevnet.com/brands/${item.brandSlug}`,
            target: '_blank',
            externalLink: true
          }]
        },
      ]));
    }
  }, [data]);
  const { isShowLeftSide, isMobileMenu } = useAppSelector(({ ui }) => ({
    isMobileMenu: ui.isMobileMenu,
    isShowLeftSide: ui.showLeftSide as boolean
  }));

  return (
    <MenuNavigation
      options={{
        dispatch,
        isShowHelp: true,
        isMobileMenu,
        toggleLeftSide,
        isShowLeftSide,
      }}
      isLoading={isLoading}
      menu={[
        {
          groupTitle: 'Account',
          menuItems: [
            {
              title: 'Home',
              href: book.userAccount,
              icon: <Home className="h-5 w-5" />,
            },
            {
              title: 'Account Info',
              href: book.userAccount,
              icon: <User className="h-5 w-5" />,
              subMenus: [
                {
                  title: 'Contact info',
                  href: book.userUpdate
                },
                {
                  title: 'Public profile',
                  href: book.userPublicProfile
                },
                {
                  title: 'Change Password',
                  href: book.userChangePassword
                },
                {
                  href: book.newsletter,
                  title: 'Newsletter Opt-in'
                },
                {
                  title: 'BevNET Magazine',
                  href: data?.magazineSubscriptionItem?.guid ? book.magazine.renew(data.magazineSubscriptionItem.guid) : book.magazine.subscribe,
                  externalLink: true
                }
              ]
            },
            {
              title: 'Brands',
              subMenus: brandsLinks,
              icon: <UserCircle className="h-5 w-5" />,
              isPermission: !!data?.userBrands.length,
            },
            { title: 'My Breweries', href: book.breweries.list, icon: <Briefcase className="h-5 w-5" />, isPermission: !!data?.userBreweries?.length },
            {
              href: book.userOrders,
              title: 'Order History',
              icon: <DollarSign className="h-5 w-5" />
            },
            {
              href: book.invoices.invoice,
              title: 'Pay an Invoice',
              icon: <CreditCard className="h-5 w-5" />
            },
            {
              externalLink: true,
              icon: <UserCircle className="h-5 w-5" />,
              title: 'Insider Subscription',
              isPermission: data?.subscriptionItem?.showSubscribeLink,
              href: `https://app.bevnet.com/subscription/${data?.subscriptionItem?.organizationGuid}/overview`
            },
            {
              href: cpgJobsUrls.listings,
              title: 'Job Listings',
              icon: <Briefcase className="h-5 w-5" />,
              externalLink: true,
            },
            {
              href: cpgJobsUrls.packages,
              title: 'Prepaid Job Packages',
              icon: <Briefcase className="h-5 w-5" />,
              externalLink: true,
            },
            {
              href: book.pressReleases.pressReleases,
              title: 'Press Releases',
              icon: <Newspaper className="h-5 w-5" />
            },
          ]
        }
      ]}
    />
  );
});
